import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { useHistory } from 'react-router-dom';

const AIButton = () => {
  const history = useHistory();

  return (
    <Button variant='outlined' size='sm' onClick={() => history.push('/ai')} startIcon={<Icon name='sparkles' />} className='h-8'>
      Assistente
    </Button>
  );
};

export default AIButton;
